import ReactGA from 'react-ga';
import {GA4_TRACKING_ID} from './Constants';

// utils/ga4.js

// Registered by userGroup.ts (kept as a hook rather than a direct import here
// to avoid a circular dependency between GAEvents <-> userGroup). Called at
// the top of every event/pageview so the GA4 user_group property is always
// backfilled -- even 'unknown'/'guest' -- before the hit fires.
let ensureHook = null;
export const registerUserGroupEnsure = fn => {
  ensureHook = fn;
};

export const pageview = url => {
  try {
    ensureHook?.();
  } catch (e) {
    //pass
  }
  window?.gtag('config', GA4_TRACKING_ID, {
    page_path: url,
  });
};

export const event = ({action, params}) => {
  try {
    ensureHook?.();
  } catch (e) {
    //pass
  }
  window?.gtag('event', action, params);
};

/**
 * Sets GA4 user properties -- these attach to every subsequent pageview/event
 * for the session (and future ones, since gtag persists them client-side),
 * not just the call site that set them.
 * @param {Record<string, string | number | boolean>} properties
 */
export const setUserProperties = properties => {
  try {
    window?.gtag('set', 'user_properties', properties);
  } catch (e) {
    //pass
  }
};

/**
 * Logs an event in Google Analytics.
 * @param {string} category - Typically the object that was interacted with (e.g., 'User', 'Navigation', 'Button').
 * @param {string} action - The type of interaction (e.g., 'click', 'submit').
 * @param {string} [label] - Optional: Additional information about the event.
 * @param {number} [value] - Optional: A numeric value associated with the event.
 */
export const logEvent = (type = 'event', action, label = '') => {
  try {
    if (type === 'event') {
      // ReactGA.event({
      //   category,
      //   action,
      //   label,
      //   value,
      // });
      event(action, label);
    } else if (type === 'pageview') {
      pageview(window.location.pathname);
      // ReactGA.pageview(window.location.pathname);
    }
  } catch (e) {
    //pass
  }
};

export const getPageLoadTime = () => {
  if (window.performance) {
    const timings = window.performance.timing;
    const loadTime = timings.loadEventEnd - timings.navigationStart;

    return loadTime; // Load time in milliseconds
  }
  return null;
};

// const usePageLoadTime = () => {
//     const startTime = useRef(new Date().getTime());
//     const isFocused = useIsFocused();

//     useEffect(() => {
//       if (isFocused) {
//         const endTime = new Date().getTime();
//         const loadTime = endTime - startTime.current;
//         return loadTime; // Load time in milliseconds
//       }
//     }, [isFocused]);

//     return null;
//   };
